/**
 * klaviyo-flyouts.js: Custom klaviyo exit intent flyout trigger when cart is non-empty
 */
console.log('Klaviyo flyouts version 1001-1219');
const data = JSON.parse(document.getElementById('klaviyo-flyouts-data').textContent);
const MAIN_FLYOUT_KLAVIYO_FORM_ID = data.mainFlyoutId;
const EXIT_INTENT_FLYOUT_DESKTOP_KLAVIYO_FORM_ID = data.desktopExitIntentFlyoutId;
const EXIT_INTENT_FLYOUT_MOBILE_KLAVIYO_FORM_ID = data.mobileExitIntentFlyoutId;
// TODO: there are two session storage keys now, so this name should be refactored
const SESSION_STORAGE_KEY = 'exitIntentFlyoutShown';
const MOBILE_EXIT_INTENT_DETECTION_CONFIG = {
  minTimeOnPageMs: 5000,     // ignore everything in the first N ms
  minDepthPx: 800,           // must have scrolled at least this far down first...
  minDepthRatio: 0.3,        // ...or this fraction of the scrollable page (whichever is smaller)
  sampleWindowMs: 150,       // velocity measured over this trailing window
  minUpwardVelocity: 1.2,    // px/ms (≈1200 px/s); raise to reduce false positives
  minUpwardDistance: 200,    // px travelled upward within the window
  touchGraceMs: 1200,        // only count scrolls within N ms of a real touch (filters anchor/JS scrolls)
  debug: true                // true = log velocity readings to console for on-device calibration
};

const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
const cartDrawer = document.querySelector('[data-cart-drawer]');
let cartHasItems = data.initialCartItemCount > 0;
let mainFlyout = null;
let shouldHideMainFlyout = false;

const debounce = (callback, wait) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
const isAlreadyShown = () => {
  try {
    return sessionStorage.getItem(SESSION_STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}
const markShown = () => {
  try {
    sessionStorage.setItem(SESSION_STORAGE_KEY, '1');
  } catch (e) {}
}
const isMainFlyoutHidden = () => {
  try {
    return sessionStorage.getItem('shouldHideMainFlyout') === '1';
  } catch (e) {
    return false;
  }
}
const setMainFlyoutHidden = (val) => {
  try {
    sessionStorage.setItem('shouldHideMainFlyout', val ? '1' : '0');
  } catch (e) {}
}
const depthThreshold = () => {
  const scrollable = document.documentElement.scrollHeight - window.innerHeight;
  return Math.min(MOBILE_EXIT_INTENT_DETECTION_CONFIG.minDepthPx, scrollable * MOBILE_EXIT_INTENT_DETECTION_CONFIG.minDepthRatio);
}
if (isMainFlyoutHidden()) console.log('Main flyout suppressed during this session')
if (isAlreadyShown()) console.log('Exit intent flyouts already shown during this session');


// update cart items whenever cart is changed
if (cartDrawer) {
  const observer = new MutationObserver(debounce(function() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => { cartHasItems = cart.item_count > 0; });
  }, 300));

  observer.observe(cartDrawer, {
    childList: true,
    subtree: true
  });
}

// register DOM element of main flyout
const observer = new MutationObserver(function(mutations, obs) {
  mainFlyout =
    document.querySelector(`.needsclick[role="dialog"]:has(form[data-testid="klaviyo-form-${MAIN_FLYOUT_KLAVIYO_FORM_ID}"])`)
    || document.querySelector(`.kl-teaser-${MAIN_FLYOUT_KLAVIYO_FORM_ID}`)?.parentElement;
  console.log('Got main flyout element:', mainFlyout);
  if (!mainFlyout) return;
  if (shouldHideMainFlyout || isMainFlyoutHidden()) mainFlyout.style.display = 'none';

  obs.disconnect();
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// desktop exit intent listener
if (!isTouchDevice && !isAlreadyShown()) {
  console.log('Adding desktop event listener');
  document.addEventListener('mouseout', function(e) {
    if (e.relatedTarget !== null) return;
    console.debug('mouseout', cartHasItems);
    if (!cartHasItems || isAlreadyShown()) return;
    console.debug('!!! triggering exit intent !!!');

    markShown();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', EXIT_INTENT_FLYOUT_DESKTOP_KLAVIYO_FORM_ID]);
    if (mainFlyout) mainFlyout.style.display = 'none';
    shouldHideMainFlyout = true;
  });
}

// mobile exit intent listener
if (isTouchDevice && !isAlreadyShown()) {
  console.log('Adding mobile event listener');
  const CONFIG = MOBILE_EXIT_INTENT_DETECTION_CONFIG;
  const loadTime = performance.now();
  let maxDepth = 0;
  let lastTouch = -Infinity;
  let samples = []; // { t, y }
  let fired = false;

  window.addEventListener('touchstart', () => { lastTouch = performance.now(); }, { passive: true });
  window.addEventListener('touchmove', () => { lastTouch = performance.now(); }, { passive: true });

  window.addEventListener('scroll', function(e) {
    if (fired || !cartHasItems || isAlreadyShown()) return;

    const now = performance.now();
    const y = Math.max(0, window.scrollY); // clamp iOS rubber-band negatives
    if (y > maxDepth) maxDepth = y;
    samples.push({ t: now, y });
    while (samples.length && now - samples[0].t > CONFIG.sampleWindowMs) samples.shift();
 
    if (now - loadTime < CONFIG.minTimeOnPageMs) return;
    if (maxDepth < depthThreshold()) return;
    if (now - lastTouch > CONFIG.touchGraceMs) return;       // not user-driven
    if (document.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return; // keyboard open
    if (samples.length < 2) return;

    const first = samples[0];
    const upward = first.y - y;                // positive = moved up
    const elapsed = now - first.t || 1;
    const velocity = upward / elapsed;         // px/ms

    if (CONFIG.debug && upward > 0) {
      console.log('[mobile-exit]', { velocity: velocity.toFixed(2), upward: Math.round(upward), y: Math.round(y) });
    }
    if (upward >= CONFIG.minUpwardDistance && velocity >= CONFIG.minUpwardVelocity) {
      fired = true;
      markShown();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', EXIT_INTENT_FLYOUT_MOBILE_KLAVIYO_FORM_ID]);
      if (mainFlyout) mainFlyout.style.display = 'none';
      shouldHideMainFlyout = true;
    }
  }, { passive: true });
}

// restore main flyout when exit intent flyout is closed (desktop + mobile)
window.addEventListener('klaviyoForms', function(e) {
  const { type, formId } = e.detail;
  // if (type === 'open' && formId === MAIN_FLYOUT_KLAVIYO_FORM_ID && shouldHideMainFlyout) {
  //   mainFlyout.style.display = 'none';
  // }
  if (type === 'close'
      && (formId === EXIT_INTENT_FLYOUT_DESKTOP_KLAVIYO_FORM_ID || formId === EXIT_INTENT_FLYOUT_MOBILE_KLAVIYO_FORM_ID)
      && mainFlyout
      && !isMainFlyoutHidden())
  {
    mainFlyout.style.display = 'block';
    shouldHideMainFlyout = false;
  } else if (type === 'submit'
              && (formId === EXIT_INTENT_FLYOUT_DESKTOP_KLAVIYO_FORM_ID || formId === EXIT_INTENT_FLYOUT_MOBILE_KLAVIYO_FORM_ID))
  {
    // hide main flyout for the rest of the session
    console.log('Hiding main flyout for rest of session');
    setMainFlyoutHidden(true);
  } else if (type === 'submit' && formId === MAIN_FLYOUT_KLAVIYO_FORM_ID) {
    console.log('Hiding exit intent popup for rest of session')
    markShown(true);
  }
});

// remove focus trap set by cart drawer so these forms work even when the cart drawer is open (desktop + mobile)
document.addEventListener('focusin', function(e) {
  const selector = (id) => `.needsclick[role="dialog"]:has(form[data-testid="klaviyo-form-${id}"])`
  if (e.target.closest(selector(MAIN_FLYOUT_KLAVIYO_FORM_ID))
      || e.target.closest(selector(EXIT_INTENT_FLYOUT_DESKTOP_KLAVIYO_FORM_ID))
      || e.target.closest(selector(EXIT_INTENT_FLYOUT_MOBILE_KLAVIYO_FORM_ID)))
  {
    e.stopImmediatePropagation();
  }
}, true);